const EMAIL_TEMPLATE_OPTIONS = [
   {
      value: 0,
      label: 'All',
      id: 0,
      name: 'All',
   },
   {
      value: 27,
      label: 'Account Created No Job Created',
      id: 27,
      name: 'Account Created No Job Created',
   },
   {
      value: 4,
      label: 'Account Rejected',
      id: 4,
      name: 'Account Rejected',
   },
   {
      value: 6,
      label: 'Account Suspended',
      id: 6,
      name: 'Account Suspended',
   },
   {
      value: 23,
      label: 'Account Upgrade Request',
      id: 23,
      name: 'Account Upgrade Request',
   },
   {
      value: 12,
      label: 'Account Upgraded',
      id: 12,
      name: 'Account Upgraded',
   },
   {
      value: 11,
      label: 'Account Verified',
      id: 11,
      name: 'Account Verified',
   },
   {
      value: 21,
      label: 'Bulk Forward Job',
      id: 21,
      name: 'Bulk Forward Job',
   },
   {
      value: 30,
      label: 'Candidate Monthly Summary',
      id: 30,
      name: 'Candidate Monthly Summary',
   },
   {
      value: 17,
      label: 'Candidate Summary',
      id: 17,
      name: 'Candidate Summary',
   },
   {
      value: 26,
      label: 'Created Job No Posting',
      id: 26,
      name: 'Created Job No Posting',
   },
   {
      value: 5,
      label: 'Credit Card Declined',
      id: 5,
      name: 'Credit Card Declined',
   },
   {
      value: 7,
      label: 'Credit Card Receipt',
      id: 7,
      name: 'Credit Card Receipt',
   },
   {
      value: 19,
      label: 'Forget Password',
      id: 19,
      name: 'Forget Password',
   },
   {
      value: 20,
      label: 'Forward Job',
      id: 20,
      name: 'Forward Job',
   },
   {
      value: 25,
      label: 'Indoctrination What to Expect',
      id: 25,
      name: 'Indoctrination What to Expect',
   },
   {
      value: 29,
      label: 'Invite Candidate',
      id: 29,
      name: 'Invite Candidate',
   },
   {
      value: 18,
      label: 'Invite User',
      id: 18,
      name: 'Invite User',
   },

   {
      value: 2,
      label: 'Job Created',
      id: 2,
      name: 'Job Created',
   },
   {
      value: 10,
      label: 'Job Unpublished',
      id: 10,
      name: 'Job Unpublished',
   },
   {
      value: 13,
      label: 'New Candidate',
      id: 13,
      name: 'New Candidate',
   },
   {
      value: 16,
      label: 'No Activity 30 and 40 Days',
      id: 16,
      name: 'No Activity 30 and 40 Days',
   },
   {
      value: 24,
      label: 'Partial Registration RP1 Only',
      id: 24,
      name: 'Partial Registration RP1 Only',
   },
   {
      value: 3,
      label: 'Pending Verification',
      id: 3,
      name: 'Pending Verification',
   },
   {
      value: 8,
      label: 'Posting Receipt',
      id: 8,
      name: 'Posting Receipt',
   },
   {
      value: 9,
      label: 'Reposting Receipt',
      id: 9,
      name: 'Reposting Receipt',
   },
   {
      value: 22,
      label: 'Request Resume',
      id: 22,
      name: 'Request Resume',
   },
   {
      value: 14,
      label: 'Resume Match to Employer',
      id: 14,
      name: 'Resume Match to Employer',
   },
   {
      value: 28,
      label: 'Resume Match to Job Seeker',
      id: 28,
      name: 'Resume Match to Job Seeker',
   },
   {
      value: 1,
      label: 'Welcome',
      id: 1,
      name: 'Welcome',
   },
];

export default EMAIL_TEMPLATE_OPTIONS;
